import { createFileRoute } from '@tanstack/react-router'
import IletisimMesajlari from '@/modules/iletisim-mesajlari'

export const Route = createFileRoute('/_authenticated/iletisim-mesajlari/')({
  component: IletisimMesajlari,
})
